import React from 'react';

interface GlareScreenProps {}

export function GlareScreen(props: Readonly<GlareScreenProps>) {
	return (
		<svg width={90} height={60} viewBox="0 0 90 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_20170)">
				<path d="M58 54h-8l.624-8h6.752L58 54z" fill="#445662" />
				<mask
					id="a"
					x={24}
					y={9}
					width={59}
					height={39}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M24 9.885h59v37.212H24V9.885z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#445662"
						d="M80.266 47H26.734C25.776 47 25 46.22 25 45.258V11.742c0-.961.776-1.742 1.734-1.742h53.532c.958 0 1.734.78 1.734 1.742v33.516C82 46.22 81.224 47 80.266 47z"
					/>
				</g>
				<path
					fill="#71828F"
					d="M26 44.42V11.58c0-.321.264-.58.59-.58H80.41c.325 0 .589.259.589.58v32.84c0 .32-.264.58-.589.58H26.59a.585.585 0 01-.589-.58z"
				/>
				<mask
					id="b"
					x={33}
					y={53}
					width={42}
					height={2}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M33.21 53.057h41.296V55H33.211v-1.944z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path
						fill="#445662"
						d="M73.54 55H34.197a.964.964 0 01-.963-.966c0-.534.431-.966.963-.966H73.54c.532 0 .963.432.963.966a.964.964 0 01-.963.966z"
					/>
				</g>
				<path d="M-.547-.473l20.868 9.134" stroke="#CFCFCF" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M-.547-.473L27 4.487" stroke="#CFCFCF" strokeWidth={0.8} strokeLinecap="round" />
				<path d="M-.547-.473l5.008 19.15" stroke="#CFCFCF" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M-.547-.473L12.81 25.355" stroke="#CFCFCF" strokeWidth={0.8} strokeLinecap="round" />
				<path d="M-.547-.473L11.14 13.67" stroke="#CFCFCF" strokeWidth={0.5} strokeLinecap="round" />
				<path d="M0 1l1 20" stroke="#CFCFCF" strokeWidth={0.8} strokeLinecap="round" strokeLinejoin="round" />
				<path
					fill="#C6C6C6"
					d="M26 44.42V11.58c0-.321.264-.58.59-.58H80.41c.325 0 .589.259.589.58l-12.216 7.215s-7.635 4.872-7.96 4.872L26.589 45a.585.585 0 01-.589-.58z"
				/>
				<path d="M-.547-.473l23.372 17.481" stroke="#CFCFCF" strokeWidth={0.8} strokeLinecap="round" />
			</g>
			<defs>
				<clipPath id="clip0_2182_20170">
					<path fill="#fff" d="M0 0H90V60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
